import { jsx, Fragment } from "react/jsx-runtime";
import { RG_TYPE, GetAllBones } from "@project-rouge/rg-core";
import { getRgObjectsOfType } from "@project-rouge/rg-three";
import { Line } from "@react-three/drei";
import { memo, useMemo } from "react";
import { MathUtils } from "three";
import { getWingPoly } from "./index175.js";
const BuildingFloorLines = memo(({ obj }) => {
  const buildings = useMemo(() => getRgObjectsOfType(obj, RG_TYPE.Building), [obj]);
  return /* @__PURE__ */ jsx(Fragment, { children: buildings.map((b) => /* @__PURE__ */ jsx(
    PerBuildingFloorLines,
    {
      building: b
    },
    b.uuid
  )) });
});
BuildingFloorLines.displayName = "BuildingFloorLines";
const PerBuildingFloorLines = memo(({
  building
}) => {
  const bones = useMemo(() => GetAllBones(building.data.anatomy), [building]);
  return /* @__PURE__ */ jsx(Fragment, { children: bones.map((bone) => /* @__PURE__ */ jsx(
    WingBoundary,
    {
      bone,
      building
    },
    bone.id
  )) });
});
PerBuildingFloorLines.displayName = "PerBuildingFloorLines";
const WingBoundary = memo(({
  building,
  bone
}) => {
  const { wingPoly, levelsAltitude } = useMemo(() => {
    const wingPoly2 = getWingPoly({ building, bone, level: bone.floors - 1 });
    const levelsAltitude2 = building.data.levels.filter((lvl) => lvl.bones.includes(bone.id)).map((lvl) => lvl.floorWorldBottom).slice(1, bone.floors);
    return { wingPoly: wingPoly2, levelsAltitude: levelsAltitude2 };
  }, [building, bone, bone.floors]);
  return /* @__PURE__ */ jsx(Fragment, { children: levelsAltitude.map((y) => /* @__PURE__ */ jsx(
    Line,
    {
      position: [0, y, 0],
      rotation: [90 * MathUtils.DEG2RAD, 0, 0],
      points: wingPoly,
      color: "#3B3B5F",
      opacity: 0.3,
      transparent: true
    },
    y
  )) });
});
WingBoundary.displayName = "WingBoundary";
export {
  BuildingFloorLines
};
//# sourceMappingURL=index44.js.map
